import type { ValueOf } from 'type-fest';

export const taglineThemes = {
  Standard: 'standard',
  Campaign: 'campaign',
  Included: 'included',
} as const;

export type Tagline = {
  onDark?: boolean;
  words: string[];
  theme?: ValueOf<typeof taglineThemes>;
  italic?: boolean;
};
